import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/ContesisLA.png'


const _withScopeId = n => (_pushScopeId("data-v-6db6ef23"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "background" }
const _hoisted_2 = { class: "menu-wrapper" }
const _hoisted_3 = { class: "menu-bar" }
const _hoisted_4 = { class: "navigation hide" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dropdown" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "for"),
  /*#__PURE__*/_createElementVNode("ul", { class: "list-menu-items" }, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "#",
        title: "enterprise"
      }, "info")
    ])
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dropdown" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "for"),
  /*#__PURE__*/_createElementVNode("ul", { class: "list-menu-items" }, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "#",
        title: "enterprise"
      }, "info")
    ])
  ])
], -1))
const _hoisted_7 = { class: "action-buttons" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Imagen",
  class: "img-fluid",
  style: {"height":"40px"}
}, null, -1))
const _hoisted_9 = {
  href: "#",
  title: "sign out",
  class: "secondary hide"
}
const _hoisted_10 = { class: "dateTime" }

import SideBar from '@/views/EstructuraS/SideBar.vue'
import { ref, watch, computed, onMounted } from 'vue'
import axios from 'axios';
import { UrlGlobal } from '@/store/dominioGlobal';
import { userGlobalStore } from '@/store/userGlobal';


export default /*#__PURE__*/_defineComponent({
  __name: 'DropDown',
  setup(__props) {

const dUrl = UrlGlobal()


let gUser = userGlobalStore()
const currentDate = ref('')
const currentTime = ref('')

const updateTime = () => {
    const now = new Date();
    currentDate.value = formatDate(now);
    currentTime.value = formatTime(now);
}

const formatDate = (date: Date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${day}/${month}/${year}`;
}

const formatTime = (date: Date) => {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
}

const usuario = ref<any[]>([]);
const compania = ref('')
const agencia = ref('')
onMounted(async () => {
    updateTime();
    setInterval(updateTime, 1000)

    const responseO = await axios.get(dUrl.urlGlobal + `/api/seguser/filter?nombre_usuario=${gUser.globalUser}`)
    usuario.value = responseO.data

    const responseCA = await axios.post(dUrl.urlGlobal +'/api/compania_agencia', {
    compania: usuario.value[0]?.compania,
    agencia: '001'
  })
    compania.value = responseCA.data.compania_desc
    agencia.value = responseCA.data.agencia_desc
})


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(SideBar),
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", null, [
            _createElementVNode("button", null, _toDisplayString(compania.value), 1),
            _hoisted_5
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("button", null, _toDisplayString(agencia.value), 1),
            _hoisted_6
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _createElementVNode("a", _hoisted_9, _toDisplayString(_unref(gUser).globalUser), 1)
          ]),
          _: 1
        }),
        _createElementVNode("span", _hoisted_10, [
          _createElementVNode("p", null, _toDisplayString(currentDate.value), 1),
          _createElementVNode("p", null, _toDisplayString(currentTime.value), 1)
        ])
      ])
    ])
  ]))
}
}

})